import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Location } from '@angular/common';
import { Sweetalert } from '../messages/alerts/sweetalert';

@Injectable({
    providedIn: 'root'
})
export class HandleErrorService implements ErrorHandler {
    constructor(private sweetalert: Sweetalert) {}

    handleError(error: HttpErrorResponse) {
        this.handling(error);

        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                    `body was: ${error.error}`
            );
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
    }

    handling(error: any): void {
        console.log('Achei erro ' + error.status);
        switch (error.status) {
            case 403 || 401:
                this.sweetalert.withoutPermission(error.message);
                break;
        }
        this.sleep(2000);
    }

    sleep(ms): Promise<any> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
